import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import classNames from "classnames";
import { UiCheckCircleIcon } from "@jti/brand-icons/ui-check-circle";
import { UiCrossIcon } from "@jti/brand-icons/ui-cross";
import { UiInfoCircleBoldIcon } from "@jti/brand-icons/ui-info-circle-bold";
import { UiWarningSolidIcon } from "@jti/brand-icons/ui-warning-solid";
import { Button } from "../Button";
import styles from "./AlertBanner.module.scss";
export const AlertBanner = ({ withIconClose = true, withVariantIcon = true, title, description, variant = "info", firstButtonHref, secondButtonHref, onFirstButtonClick, onSecondButtonClick, buttonFirstText, buttonSecondText, onClose, cta, shouldCloseOnCtaClick = true, }) => {
    const backgroundStyle = classNames(styles.wrapper, styles[variant] || styles.info);
    const [isOpen, setIsOpen] = useState(true);
    const handleClose = useCallback(() => {
        if (onClose)
            onClose();
        setIsOpen(false);
    }, [onClose]);
    const applyGap = [description, buttonFirstText, buttonSecondText].some(Boolean);
    if (!isOpen)
        return null;
    const iconComponent = {
        info: _jsx(UiInfoCircleBoldIcon, { height: 32, width: 32 }),
        success: _jsx(UiCheckCircleIcon, { height: 32, width: 32 }),
        warning: _jsx(UiInfoCircleBoldIcon, { height: 32, width: 32 }),
        error: _jsx(UiWarningSolidIcon, { height: 32, width: 32 }),
    };
    const getButtonProps = ({ onClick, href, color }) => {
        const onClickHandler = () => {
            onClick?.();
            if (shouldCloseOnCtaClick) {
                handleClose();
            }
        };
        const baseProps = {
            variant: "cta",
            size: "small",
            color,
            onClick: onClickHandler,
        };
        if (!href) {
            return baseProps;
        }
        return { ...baseProps, href };
    };
    const firstButtonProps = getButtonProps({
        onClick: onFirstButtonClick,
        href: firstButtonHref,
        color: "primary",
    });
    const secondButtonProps = getButtonProps({
        onClick: onSecondButtonClick,
        href: secondButtonHref,
        color: "secondary",
    });
    return (_jsx("div", { className: backgroundStyle, "data-testid": "info-banner-wrapper", children: _jsxs("div", { className: classNames(styles.innerWrapper, { [styles.applyGap]: applyGap }), children: [_jsxs("div", { className: styles.top, children: [withVariantIcon && (_jsx("div", { className: classNames(styles.alertIcon, {
                                [styles.alertIconWithThemes]: variant === "info",
                            }), "data-testid": "variant-icon", children: iconComponent[variant] })), _jsxs("div", { className: styles.content, children: [_jsxs("div", { className: classNames(styles.texts, {
                                        [styles.textWithThemes]: variant === "info",
                                    }), children: [title && _jsx("div", { className: styles.title, children: title }), _jsx("div", { className: styles.description, children: description })] }), _jsx("div", { children: cta?.text && cta.link ? (_jsx(Button, { variant: "redirect", color: "tertiary", href: cta.link, size: "small", children: cta.text })) : (_jsxs("div", { className: styles.buttons, children: [buttonFirstText && _jsx(Button, { ...firstButtonProps, children: buttonFirstText }), buttonSecondText && _jsx(Button, { ...secondButtonProps, children: buttonSecondText })] })) })] }), withIconClose && (_jsx("div", { onClick: handleClose, "data-testid": "close-button", className: classNames(styles.closeIcon, {
                                "light-theme": variant !== "info",
                            }), children: _jsx(UiCrossIcon, { height: 32, width: 32 }) }))] }), _jsxs("div", { className: styles.bottomButtons, children: [buttonFirstText && _jsx(Button, { ...firstButtonProps, children: buttonFirstText }), buttonSecondText && _jsx(Button, { ...secondButtonProps, children: buttonSecondText })] })] }) }));
};
//# sourceMappingURL=AlertBanner.js.map